import axios from "@/index";
const product = {
  state: {
    productGroupList: [],
    productBaseDataXTList: [],
    brandClassInfo: []
  },
  getters: {},
  actions: {
    getProductGroupCodeList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setProductGroupCodeList",
                (state, { productGroupList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getBaseDataXtList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setBaseDataXtList",
                (state, { productBaseDataXTList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getBrandClassInfo: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setBrandClassInfo",
                (state, { brandClassInfo: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setProductGroupCodeList(state, action) {
      state.productGroupList = action.productGroupList;
    },
    setBaseDataXtList(state, action) {
      state.productBaseDataXTList = action.productBaseDataXTList;
    },
    setBrandClassInfo(state, action) {
      state.brandClassInfo = action.brandClassInfo;
    }
  }
};
export default product;
